/**
 * GHL / LeadConnector chat widget helper.
 *
 * The widget is loaded site-wide from index.html via
 * https://beta.leadconnectorhq.com/loader.js (data-widget-id). It renders its
 * own floating launcher, so end users can always open chat from the bubble.
 *
 * openChatWidget() is the replacement for the old window.Intercom('show') /
 * window.Intercom('showNewMessage') calls used by the in-app help surfaces
 * (Need Help, Help Center, first-visit prompt).
 *
 * LeadConnector does not publish a stable public JS API, so we try the known
 * entry points in order and fall back to clicking the widget's launcher button.
 * NOTE: verify on the preview deploy and trim to whichever path the live widget
 * actually uses.
 */

const getWidgetElement = () => document.querySelector('chat-widget');

export const openChatWidget = () => {
  // 1) Global API exposed by the LeadConnector loader, if present.
  const api = window.leadConnector || window.LC_API;
  if (api) {
    if (typeof api.openWidget === 'function') return api.openWidget();
    if (api.chatWidget && typeof api.chatWidget.openWidget === 'function') {
      return api.chatWidget.openWidget();
    }
  }

  // 2) The loader injects a <chat-widget> custom element that may expose a method.
  const el = getWidgetElement();
  if (el && typeof el.openWidget === 'function') return el.openWidget();

  // 3) Fall back to clicking the widget's launcher button (shadow DOM or light DOM).
  const launcher =
    el?.shadowRoot?.querySelector('button, [class*="launcher"], [class*="Launcher"]') ||
    el?.querySelector('button, [class*="launcher"], [class*="Launcher"]');
  if (launcher) return launcher.click();

  return undefined;
};

export default openChatWidget;
